module.exports = __webpack_public_path__ + "img/hg.52557ff1.png";